export const SCENE_BULLETS = [
  {
    text: "Played a pivotal role in critical decision-making for designing and implementing both frontend and backend systems",
    keyWords: ["pivotal", "designing", "implementing", "frontend", "backend"],
  },
  {
    text: "Successfully executed diverse React frontend tasks, encompassing comprehensive component updates and the integration of new routes. Leveraged advanced libraries such as Apollo, Lodash, and Material UI",
    keyWords: [
      "diverse",
      "tasks,",
      "comprehensive",
      "updates",
      "Leveraged",
      "libraries",
    ],
  },
  {
    text: "Proactively managed and reduced technical debt by consistently modernizing and standardizing common application components. This involved updating or eliminating outdated or unused dependencies, streamlining logic, and enhancing tests and type definitions",
    keyWords: [
      "managed",
      "debt",
      "consistently",
      "standardizing",
      "eliminating",
      "streamlining",
      "enhancing",
    ],
  },
  {
    text: "Provided robust support to frontend operations with Node backend services through GraphQL endpoints. This entailed executing seeds and migrations, maintaining endpoint schema and types, and rigorously testing the API using tools like GraphiQL or Thunder Client for VSCode",
    keyWords: [
      "robust",
      "backend",
      "seeds",
      "migrations,",
      "schema",
      "testing",
      "tools",
    ],
  },
  {
    text: "Developed sophisticated backend SQL statements for data pagination, filtering, and sorting, alongside other standard queries and mutations, primarily utilizing PostgreSQL",
    keyWords: ["sophisticated", "SQL", "queries", "mutations,"],
  },
  {
    text: "Collaborated seamlessly within a dynamic team, ensuring effective communication through platforms like Slack to meet biweekly deadlines consistently",
    keyWords: ["seamlessly", "dynamic", "communication", "meet", "deadlines"],
  },
  {
    text: "Cultivated expertise in best practices and standards for professional software development",
    keyWords: ["expertise", "practices", "professional"],
  },
  {
    text: "Elevated public speaking skills through regular biweekly project demos, showcasing recent releases",
    keyWords: ["speaking", "biweekly", "demos,"],
  },
  {
    text: "Contributed to the onboarding and mentorship of new engineering team members",
    keyWords: ["onboarding", "new", "members"],
  },
];

export const SCENE_SKILLS = [
  "JavaScript",
  "HTML",
  "CSS",
  "React",
  "Node",
  "PostgreSQL",
  "Git",
  "Bitbucket",
  "AWS",
  "Figma",
];
